export const defaultSelectedVouchersType = () => {
    return {
        branchoffice_id: '',
        code_voucher_type: '',
        name_voucher_type: '',
        short_name: '',
        prefix: '',
        consecutive_number: '',
        electronic_bill: 0,
        unreferenced_document: 0,
        resolution: '',
        affectation: '',
        state: 1,
        only_consecutive: 0,
        range_from:null,
        range_up:null,
        origin_document: 0,
        print_firms:0,
        electronic_document_id: null,
        document_nature_id: null,
        select_seller: 0,
        select_correreria: 0,
    }
}
export default {
  vouchersTypes: [],
  selectedVouchersType: defaultSelectedVouchersType(),
  error: false,
  errorMessage: '',
  action: 'create',
  branchOffices: [],
  electronic_documents: [],
  documents_nature: [],
  loading :false,
  getVouchesTypeEdit: true,


  params: {
    paginate: true,
    page: 1,
    perPage: 15,
    filter: '',
    sortBy: 'code_voucher_type',
    sort: 'ASC',
    branchoffice: null
  }
};



// WEBPACK FOOTER //
// ./src/modules/vouchers-types/state.js